import React, { useEffect, useState } from "react";
import Dashboard from "../layouts/Dashboard";
import { Card, Col, Row } from "antd";
import $ from "jquery";
import { Button } from "reactstrap";
import axios from "../services/axios";
import XTable from "./XTable";
import { message } from "antd";
import { If } from "react-condition";
import ReactLoading from "react-loading";
import isConsultant from "../services/isConsultant";
import { checkPermission } from "../utils/checkPermission";
import useRole from "../hooks/useRole";
  

//datatable
var dt = require("datatables.net");
require("datatables.net-bs4");
$.DataTable = dt;

const ClientMapping = (props) => {
  const [process, setProcess] = useState();
  const [tableData, setTableData] = useState();
  const [refresh, setRefresh] = useState(false);
  const [clientError, setClientError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [processError, setProcessError] = useState("");
  const [load, setLoad] = useState(false);
  const [canCreateClientMapping, setCanCreateClientMapping] = useState(false);
  const [canEditClientMapping, setCanEditClientMapping] = useState(false);
  const userRole = useRole();

  const checkPermissions = async () => {
    try {
      const createAllowed = await checkPermission(
        userRole,
        "client_mapping_module",
        "create_client_mapping"
      );
      const editAllowed = await checkPermission(
        userRole,
        "client_mapping_module",
        "edit_client_mapping"
      );
      setCanCreateClientMapping(createAllowed);
      setCanEditClientMapping(editAllowed);
    } catch (err) {
      console.error("Error checking client mapping permissions:", err);
    }
  };

  useEffect(() => {
    checkPermissions();
  }, [userRole]);

  const success = (e) => {
    if (e === "submit") {
      message.success("Client mapped, Successfully", 5);
    } else {
      message.error("Mobile or Email already exist", 5);
    }
  };

  useEffect(() => {
    axios
      .get(`/processes/processList`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        const data = res.data.processes;
        setProcess(data);
      });

    axios
      .get("/clientProcess", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        const data = res.data;
        console.log("response da", data);
        setTableData(data);
      });
  }, [refresh]);

  const [processId, setProcessId] = useState("");

  const handleProcessId = (e) => {
    setProcessError("");
    // console.log("processId", e.target.value);
    setProcessId(e.target.value);
  };

  const [clientName, setClientName] = useState("");

  const handleClientName = (e) => {
    setClientError("");
    const alphabets = /^[-a-zA-Z][-a-zA-Z ]*$/;
    if (!e.target.value.match(alphabets)) {
      setClientError("Only alphabets are allowed");
    }
    // console.log("processId", e.target.value);
    setClientName(e.target.value);
  };

  const [email, setEmail] = useState("");

  const handleEmail = (e) => {
    setEmailError("");
    // console.log("processId", e.target.value);
    const emailValidate = /\S+@\S+\.\S+/;
    if (e.target.value.length === 0) {
      setEmailError("");
    } else if (!e.target.value.match(emailValidate)) {
      setEmailError("invalid email format");
    }
    setEmail(e.target.value);
  };

  const [phone, setPhone] = useState();

  

  const handlePhone = (e) => {
    const phoneValue = e.target.value;
    setPhone(phoneValue);

    if (phoneValue.length === 0) {
      setPhoneError("");
    } else if (!/^[0-9]{10}$/.test(phoneValue)) {
      setPhoneError("Please enter a valid 10-digit phone number");
    } else {
      setPhoneError("");
    }
  };


  const handleCreate = (e) => {
    e.preventDefault();
    if (phoneError === "" && clientError === "" && emailError === "") {
      if (clientName === "") {
        setClientError("Name is required");
      } else if (email === "") {
        setEmailError("Email is required");
      }
      //  else if (phone === "") {
      //   setPhoneError("Phone number is required");
      // }
      else if (processId === "") {
        setProcessError("Process is required");
      } else {
        setRefresh(false);
        setLoad(true);
        axios
          .post(
            "/clientProcess",
            {
              name: clientName?.replace(/\s{2,}/g, " ").trim(),
              email: email?.replace(/\s{2,}/g, " ").trim(),
              phone: phone?.replace(/\s{2,}/g, " ").trim(),
              processId: processId,
              status: true,
              role: "client",
              loginUserId : localStorage.getItem('user.id')
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("user.token")}`,
              },
            }
          )
          .then((res) => {
            const data = res;
            // console.log("data", data);

            setRefresh(true);
            setClientName("");
            setEmail("");
            setPhone("");
            setProcessId("");
            setLoad(false);
            success("submit");
          })
          .catch((err) => {
            setLoad(false);
            success("error");
          });
      }
    }
  };
  const [toggleButton, setToggleButton] = useState(false);
  const [userId, setUserId] = useState("");

  const handleEdit = (id) => {
    axios
      .get(`clientProcess/userId/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        setToggleButton(true);
        setClientName(res?.data?.userList[0]?.name);
        setPhone(res?.data?.userList[0]?.phone);
        setEmail(res?.data?.userList[0]?.email);
        setProcessId(res?.data?.userList[0]?.processId[0]);
        setUserId(res?.data?.userList[0]?._id);
      });
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    if (phoneError === "" && clientError === "" && emailError === "") {
      if (clientName === "") {
        setClientError("Name is required");
      } else if (email === "") {
        setEmailError("Email is required");
      }
      //  else if (phone === "") {
      //   setPhoneError("Phone number is required");
      // }
      else if (processId === "") {
        setProcessError("Process is required");
      } else {
        setRefresh(false);
        setLoad(true);
        axios
          .put(
            "/clientProcess/" + userId,
            {
              name: clientName.replace(/\s{2,}/g, " ").trim(),
              email: email.replace(/\s{2,}/g, " ").trim(),
              phone: phone.replace(/\s{2,}/g, " ").trim(),
              processId: processId,
              status: true,
              role: "client",
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("user.token")}`,
              },
            }
          )
          .then((res) => {
            const data = res;
            // console.log("data", data);

            setRefresh(true);
            setClientName("");
            setEmail("");
            setPhone("");
            setProcessId("");
            setLoad(false);
            success("submit");
          })
          .catch((err) => {
            setLoad(false);
            success("error");
          })
          .finally((res) => {
            setToggleButton(false);
          });
      }
    }
  };
  return (
    <div>
      {!isConsultant() && (
        <Dashboard title="Client Mapping">
          {load && (
            <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
          )}
          <div className="row mb-4">
              <div className="col-lg-4">
                <div>
                  <Card className="border">
                    <div>
                      <div>
                        <label>Process</label>
                        <select
                          id="FormType"
                          className="form-control"
                          onChange={handleProcessId}
                          value={processId}
                        >
                          <option value="" selected>
                            Select Process...
                          </option>
                          {process?.map((ele) => {
                            return <option value={ele._id}>{ele.name}</option>;
                          })}
                        </select>
                        {processError && (
                          <div
                            className="text-danger"
                            style={{ marginTop: 5 + "px" }}
                          >
                            {processError}
                          </div>
                        )}
                      </div>

                      <div className="mt-2">
                        <label>Client Name</label>
                        <input
                          placeholder="Enter Client Name"
                          onChange={handleClientName}
                          value={clientName}
                          type="text"
                          class="form-control"
                          id="usr"
                        />
                        {clientError && (
                          <div
                            className="text-danger"
                            style={{ marginTop: 5 + "px" }}
                          >
                            {clientError}
                          </div>
                        )}
                      </div>

                      <div className="mt-2">
                        <label>Email</label>
                        <input
                          placeholder="Enter Email"
                          onChange={handleEmail}
                          value={email}
                          type="email"
                          class="form-control"
                          id="usr"
                        />
                        {emailError && (
                          <div
                            className="text-danger"
                            style={{ marginTop: 5 + "px" }}
                          >
                            {emailError}
                          </div>
                        )}
                      </div>

                      <div className="mt-2">
                        <label>Phone</label>
                        <input
                          placeholder="Enter Phone Number"
                          onChange={handlePhone}
                          value={phone}
                          type="text"
                          class="form-control"
                          id="usr"
                        />
                        {phoneError && (
                          <div
                            className="text-danger"
                            style={{ marginTop: 5 + "px" }}
                          >
                            {phoneError}
                          </div>
                        )}
                      </div>
                      {canCreateClientMapping && (
                        <>
                        {!toggleButton ? (
                          <button
                            onClick={handleCreate}
                            className="btn btn-primary mt-3"
                          >
                            Create
                          </button>
                        ) : (
                          <div style={{ display: "flex", gap: "10px" }}>
                            <button
                              onClick={handleUpdate}
                              className="btn btn-primary mt-3"
                            >
                              Update
                            </button>

                            <button
                              onClick={() => {
                                setToggleButton(false);
                                setClientName("");
                                setPhone("");
                                setEmail("");
                                setProcessId("");
                                setUserId("");
                              }}
                              className="btn btn-primary mt-3"
                            >
                              Back
                            </button>
                          </div>
                        )}
                        </>
                      )}
                    </div>
                  </Card>
                </div>
              </div>
            <div className="col-lg-8">
              <Card className="border">
                <XTable
                  columns={[
                    "ID",
                    "Name",
                    "Process",
                    "Email",
                    "Phone",
                    "Action",
                  ]}
                  rows={tableData?.map((ele) => {
                    return {
                      ID: ele._id,
                      Name: ele.name,
                      Process: ele?.processId[0]?.name,
                      Email: ele.email,
                      Phone: ele.phone,
                      Action: (
                        <div style={{ display: "flex" }}>
                          {canEditClientMapping && (
                            <Button
                              size="sm"
                              type="primary"
                              className="btn btn-primary"
                              onClick={() => {
                                handleEdit(ele._id);
                              }}
                            >
                              <i class="fa fa-edit"></i> Edit
                            </Button>
                          )}
                        </div>
                      ),
                    };
                  })}
                />
              </Card>
            </div>
          </div>
        </Dashboard>
      )}
    </div>
  );
};

export default ClientMapping;
